module.exports = __webpack_public_path__ + "img/guilin.b33ddf0a.jpg";